const images = {
  instagram: require("./instagram.png").default,
  landscapeMode: require("./landscapemode.jpg").default,
  linkedin: require("./linkedin.png").default,
  logoWithName: require("./logo-with-name.png").default,
  whatsapp: require("./whatsapp.png").default,
};

export default images;
